import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface ModalFooterProps {
  columns?: number;
  centerButtons?: boolean;
}

const ModalFooter = styled.footer<ModalFooterProps>`
  position: relative;
  bottom: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: center;
  gap: ${toRem(theme.space.md)};
  justify-items: center;
  align-items: center;
  width: 100%;
  height: auto;
  padding-top: ${toRem(theme.space['2xl'])};

  > button {
    width: 100%;

    &:first-child {
      order: -1;
    }
  }

  ${({ centerButtons }) =>
    centerButtons &&
    css`
      display: flex;

      > button {
        width: auto;
      }
    `}

  @media (width < ${theme.breakpoint.small}px) {
    display: grid;

    > button {
      width: 100%;

      &:first-child {
        order: 1;
      }
    }
  }

  ${({ columns }) =>
    columns === 1
      ? css`
          grid-template-columns: 1fr;

          > button {
            width: auto;
          }

          > * {
            &:first-child {
              justify-self: auto;
            }

            &:last-child {
              justify-self: auto;
            }
          }
        `
      : css`
          grid-template-columns: 1fr;

          @media (min-width: ${theme.breakpoint.small}px) {
            grid-template-columns: repeat(${columns}, 1fr);
          }
        `}
`;

export default ModalFooter;
